import { useForm } from 'react-hook-form';
import { FORM_SEARCH, searchDefaultValues } from '../form';
import { useGetRegFull } from './useGetRegFull';
import { useGetRegDate } from './useGetRegDate';
import { useCallback, useEffect, useState } from 'react';
import { useDelReg } from './useDelReg';
import { navigateTo } from '../../../../utils/navigation';
import { ROUTES_PATH } from '../../../../resources/routes-name';

export const useGetRegList = () => {
  const [searchType, setSearchType] = useState('date');
  const [isInitialFetch, setIsInitialFetch] = useState(true);
  const formSearchObj = useForm({ defaultValues: searchDefaultValues });

  const {
    dataSource: dataFull,
    onFetchFull,
    isLoadingFull,
  } = useGetRegFull({ handleSubmit: formSearchObj.handleSubmit });

  const {
    dataSource: dataDate,
    onFetch,
    isLoading,
  } = useGetRegDate({ handleSubmit: formSearchObj.handleSubmit });

  const { mutate: handleDelete, loading: isloadingToDel } = useDelReg({
    onSuccessCallBack: onFetch,
  });

  const onSearch = (values) => {
    if (values.search) {
      setSearchType('search');
      onFetchFull(values);
    } else if (values.startDate) {
      setSearchType('date');
      onFetch(values);
    }
  };

  const formSearch = FORM_SEARCH({ onEnter: formSearchObj.handleSubmit(onSearch) });

  const linkToRegistrationAdd = useCallback(() => {
    navigateTo({ pathname: ROUTES_PATH.ROUTE_REGISTRATION_ADD.PATH });
  }, []);

  const transformDataForExcel = (data) => {
    return data?.map((item) => ({
      warrantyCode: item.warrantyCode,
      warrantyNumberCode: item.warrantyNumberCode,
      categoryCode: item.categoryCode || '-',
      warrantyStatus: item.warrantyStatus,
      mobileBrandName: item.mobileBrandName,
      mobileModelName: item.mobileModelName,
      itemCode: item.itemCode,
      productName: item.productName,
      channelBuyName: item.channelBuyName,
      fullName: item.fullName,
      telephone: item.telephone,
      email: item.email || '-',
      createDate: item.createDate,
      claimCode: item.claimCode,
      claimRemark: item.claimRemark,
      claimDate: item.claimDate,
      expireDate: item.expireDate,
      purchaseDate: item.purchaseDate,
      warrantyStatusName: item.warrantyStatusName,
      lineUid: item.lineUid,
    }));
  };

  useEffect(() => {
    if (location.state && isInitialFetch) {
      formSearchObj.handleSubmit(onFetch)();
      setIsInitialFetch(false);
    } else {
      onFetch();
    }
  }, [location.state, isInitialFetch]);

  return {
    formSearch,
    dataFull,
    onFetchFull,
    isLoadingFull,
    formSearchObj,
    dataDate,
    onFetch,
    isLoading,
    onSearch,
    searchType,
    isInitialFetch,
    transformDataForExcel,
    handleDelete,
    isloadingToDel,
    linkToRegistrationAdd,
  };
};
